import zero from "./man_with_phone.png";
import one from "./woman_with_phone.png";
import two from "./seebeck_logo_white.svg";
import three from "./front_detail.png";
import four from "./box_detail.png";
import five from "./sholder_detail.png";
import six from "./man_with_phone_white.png";
import seven from "./woman_with_phone_black.png";
import eight from "./charging_together.png";
import nine from "./pep_logo.svg";
import ten from "./infographic.png";
import eleven from "./happy_town.png";
import twelve from "./team.png";
import thirteen from "./desert.jpg";
import fourteen from "./ice.jpg";
import fifteen from "./two_people_charging.png";
import sixteen from "./woman_with_phone_to_side.png";

export const black = zero;
export const white = one;
export const logo = two;
export const front_detail = three;
export const box_detail = four;
export const sholder_detail = five;
export const man_with_phone_white = six;
export const woman_with_phone_black = seven;
export const charging_together = eight;
export const pep_logo = nine;
export const infographic = ten;
export const happy_town = eleven;
export const team = twelve;
export const desert = thirteen;
export const ice_break = fourteen;
export const two_people_charging = fifteen;
export const woman_with_phone_to_side = sixteen;
